export { default as getSortFromViewMode } from './getSortFromViewMode';
